import { Navigate, Route, Routes } from "react-router-dom";
import App from "../components/app/App";
import type { FC } from "react";
import JsonFormatter from "../components/jsonformatter/JsonFormatter";
import TextDiff from "../components/textdiff/TextDiff";
import WordCounter from "../components/wordcounter/WordCounter";
import CronGenerator from "../components/crongenerator/CronGenerator";
import Base64Tool from "../components/base64/Base64Tool";
import JwtDecoder from "../components/jwtdecoder/JwtDecoder";
import HtmlXmlFormatter from "../components/htmlxmlformatter/HtmlXmlFormatter";
import RegexTester from "../components/regextester/RegexTester";
import UuidGenerator from "../components/uuidgenerator/UuidGenerator";
const SwitchRoutes: FC = () =>

(
    <Routes>
        <Route path="/" element={<App />} />
        <Route path="/json-formatter" element={<JsonFormatter />} />
        <Route path="/text-diff" element={<TextDiff />} />
        <Route path="/word-counter" element={<WordCounter />} />
        <Route path="/cron-generator" element={<CronGenerator />} />
        <Route path="/base64-encoder-decoder" element={<Base64Tool />} />
        <Route path="/jwt-decoder" element={<JwtDecoder />} />
        <Route path="/html-xml-formatter" element={<HtmlXmlFormatter />} />
        <Route path="/regex-tester" element={<RegexTester />} />
        <Route path="/uuid-generator" element={<UuidGenerator />} />
        <Route path="*" element={<Navigate to="/" />} />
    </Routes>
)



export default SwitchRoutes;